import { Link } from 'react-router-dom';
import StatusBadge from '@/components/base/StatusBadge';
import FavoriteButton from '@/components/base/FavoriteButton';
import { TYPE_LABELS, REGION_LABELS, type Work } from '@/types/work';
import { formatDate } from '@/lib/works';

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <article className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/detail/${work.id}`} className="flex flex-col">
        <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
          <img
            src={work.cover}
            alt={`${work.title} 中文字幕封面`}
            title={`${work.title} - 日韩中文字幕`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent"></div>
          <div className="absolute left-2.5 top-2.5">
            <StatusBadge status={work.subtitleStatus} />
          </div>
          <FavoriteButton id={work.id} className="absolute right-2.5 top-2.5" />
          <span className="absolute bottom-2.5 left-2.5 rounded-full bg-background-50/90 px-2 py-0.5 text-[11px] font-medium text-foreground-800">
            {TYPE_LABELS[work.type]}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-3.5">
          <h3 className="line-clamp-1 text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
            {work.title}
          </h3>
          <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
            {work.originalTitle}
          </p>
          <div className="mt-2.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-foreground-500">
            <span className="inline-flex items-center gap-1">
              <i className="ri-map-pin-line"></i>
              {REGION_LABELS[work.region]}
            </span>
            <span className="text-background-300">|</span>
            <span>{work.year}</span>
            <span className="text-background-300">|</span>
            <span className="line-clamp-1">{work.genre.split(' / ')[0]}</span>
          </div>
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
            {work.description}
          </p>
          <div className="mt-auto flex items-center justify-between pt-3 text-[11px] text-foreground-400">
            <span className="inline-flex items-center gap-1">
              <i className="ri-refresh-line"></i>
              {formatDate(work.updatedAt)} 更新
            </span>
            <span className="inline-flex items-center gap-1 text-accent-600">
              <i className="ri-fire-line"></i>
              {work.popularity}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}